import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { CheckCircle2, XCircle, Star, RefreshCw } from "lucide-react";

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/testimonials").then((r) => setItems(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const moderate = async (testimonialId, status, isFeatured) => {
    await api.patch(`/admin/testimonials/${testimonialId}`, { status, is_featured: isFeatured });
    await load();
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-12" data-testid="admin-testimonials-page">
      <div className="flex items-center justify-between gap-3 mb-8">
        <div>
          <p className="label">Admin</p>
          <h1 className="font-heading text-3xl font-black">Avis apprenants</h1>
          <p className="text-sm text-gray-600 mt-1">Valide les avis avant affichage sur la page d’accueil.</p>
        </div>
        <button type="button" onClick={load} className="btn-ghost"><RefreshCw className="w-4 h-4" /> Actualiser</button>
      </div>

      {loading ? <p className="text-gray-500">Chargement...</p> : items.length === 0 ? (
        <div className="card p-8 text-center text-gray-500">Aucun avis pour le moment.</div>
      ) : (
        <div className="space-y-4">
          {items.map((item) => (
            <div key={item.testimonial_id} className="card p-5" data-testid={`admin-testimonial-${item.testimonial_id}`}>
              <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className={`badge ${item.status === "approved" ? "" : item.status === "rejected" ? "bg-red-50 text-red-700 border-red-100" : "orange"}`}>{item.status}</span>
                    {item.is_featured && <span className="badge">Affiché accueil</span>}
                    <span className="text-sm text-gray-500">{item.course_title}</span>
                  </div>
                  <div className="flex items-center gap-1 text-amber-500 mb-3">
                    {[1, 2, 3, 4, 5].map((rating) => <Star key={rating} className={`w-4 h-4 ${item.rating >= rating ? "fill-current" : "text-gray-200"}`} />)}
                  </div>
                  <p className="font-semibold">{item.user_name || "Apprenant"}</p>
                  <p className="text-gray-700 mt-2 whitespace-pre-line">{item.text}</p>
                  <p className="text-xs text-gray-400 mt-3">Envoyé le {item.created_at ? new Date(item.created_at).toLocaleString("fr-FR") : "-"}</p>
                </div>
                <div className="flex flex-wrap gap-2 lg:justify-end shrink-0">
                  <button onClick={() => moderate(item.testimonial_id, "approved", true)} className="btn-primary !px-4 !py-2 text-sm"><CheckCircle2 className="w-4 h-4" /> Valider</button>
                  <button onClick={() => moderate(item.testimonial_id, "approved", false)} className="btn-ghost !px-4 !py-2 text-sm">Valider sans accueil</button>
                  <button onClick={() => moderate(item.testimonial_id, "rejected", false)} className="text-red-600 hover:text-red-700 rounded-xl border border-red-100 px-4 py-2 text-sm font-semibold"><XCircle className="w-4 h-4 inline mr-1" /> Refuser</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
